import { render, staticRenderFns } from "./AccountAccess.vue?vue&type=template&id=3cf6ecf4&scoped=true"
import script from "./AccountAccess.vue?vue&type=script&lang=js"
export * from "./AccountAccess.vue?vue&type=script&lang=js"
import style0 from "./AccountAccess.vue?vue&type=style&index=0&id=3cf6ecf4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf6ecf4",
  null
  
)

export default component.exports